import { Button } from "primereact/button";

import "./style.scss";

const ButtonUI = (props) => <Button {...props} className={`button-ui ${props.className} ${props.type}`} />;

export default ButtonUI;
